import { render, staticRenderFns } from "./PopupConfirmacao.vue?vue&type=template&id=6e813163&scoped=true"
import script from "./PopupConfirmacao.vue?vue&type=script&lang=js"
export * from "./PopupConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./PopupConfirmacao.vue?vue&type=style&index=0&id=6e813163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e813163",
  null
  
)

export default component.exports